import { styled } from '@mui/material/styles'
import { DataGridPremium } from '@mui/x-data-grid-premium'

export const Table = styled(DataGridPremium)(({ theme }) => ({
  // Force hardware acceleration and smooth rendering
  transform: 'translateZ(0)',
  backfaceVisibility: 'hidden',
  
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: '0px',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bold',
  },
  '& .MuiDataGrid-columnHeader--pinnedLeft': {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: theme.palette.common.white,
  },
  // Set default backgrounds to prevent white flashes during virtualization
  '& .MuiDataGrid-virtualScroller': {
    backgroundColor: theme.palette.background.default,
  },
  '& .MuiDataGrid-main': {
    backgroundColor: theme.palette.background.default,
  },
  '& .MuiDataGrid-row': {
    backgroundColor: theme.palette.background.default,
  },
  '& .MuiDataGrid-cell': {
    backgroundColor: 'inherit',
    // Force immediate rendering
    transform: 'translateZ(0)',
  },
  // Set alternating row colors using stable row classes
  '& .MuiDataGrid-row.row--odd': {
    backgroundColor: '#f5f5f5',
    '& .MuiDataGrid-cell': {
      backgroundColor: 'inherit',
    },
  },
  '& .MuiDataGrid-row.row--even': {
    backgroundColor: theme.palette.background.default,
    '& .MuiDataGrid-cell': {
      backgroundColor: 'inherit',
    },
  },
  // Override pinned cells to always be white with higher specificity
  '& .MuiDataGrid-cell--pinnedLeft': {
    backgroundColor: `${theme.palette.common.white} !important`,
  },
  '& .MuiDataGrid-row.row--odd .MuiDataGrid-cell--pinnedLeft': {
    backgroundColor: `${theme.palette.common.white} !important`,
  },
  '& .MuiDataGrid-row.row--even .MuiDataGrid-cell--pinnedLeft': {
    backgroundColor: `${theme.palette.common.white} !important`,
  },
  '& .MuiDataGrid-cell--pinnedLeft.MuiDataGrid-cell--editable': {
    backgroundColor: `${theme.palette.common.white} !important`,
  },
  '& .MuiDataGrid-row.row--edited .MuiDataGrid-cell--pinnedLeft': {
    backgroundColor: `${theme.palette.common.white} !important`,
  },
  '& .MuiDataGrid-row.row--edited': {
    backgroundColor: () => {
      return 'rgba(255, 254, 176, 0.3)'
    },
  },
  '& .MuiDataGrid-row .MuiDataGrid-cell--editable': {
    backgroundColor: '#CBD5E1 !important',
    cursor: 'pointer',
  },
  // Fix dropdown sizing for singleSelect columns
  '& .MuiDataGrid-cell--editing .MuiSelect-root': {
    width: '100%',
    minWidth: '100%',
  },
  '& .MuiDataGrid-cell--editing .MuiSelect-select': {
    padding: '8px 12px',
    minHeight: 'auto',
  },
  '& .MuiSelect-paper': {
    maxWidth: '200px',
    minWidth: '150px',
  },
}))
